<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="svgWidth" :height="svgHeight" viewBox="0 0 14.998 14.187" :class="iconCssClass">
    <g data-id="btn-share" transform="translate(1 1)">
      <circle data-id="Ellipse_2" data-name="Ellipse 2" cx="1.912" cy="1.912" r="1.912" transform="translate(0 4.461)" :fill="svgFill" :stroke="svgStroke" stroke-linecap="round" stroke-linejoin="round" :stroke-width="svgStrokeWidth"/>
      <circle data-id="Ellipse_3" data-name="Ellipse 3" cx="1.912" cy="1.912" r="1.912" transform="translate(9.174)" :fill="svgFill" :stroke="svgStroke" stroke-linecap="round" stroke-linejoin="round" :stroke-width="svgStrokeWidth"/>
      <circle data-id="Ellipse_4" data-name="Ellipse 4" cx="1.912" cy="1.912" r="1.912" transform="translate(9.174 8.363)" :fill="svgFill" :stroke="svgStroke" stroke-linecap="round" stroke-linejoin="round" :stroke-width="svgStrokeWidth"/>
      <line data-id="Line_36" data-name="Line 36" x2="5.639" y2="2.195" transform="translate(3.535 7.377)" :fill="svgFill" :stroke="svgStroke" stroke-linecap="round" stroke-linejoin="round" :stroke-width="svgStrokeWidth"/>
      <line data-id="Line_37" data-name="Line 37" y1="2.195" x2="5.639" transform="translate(3.535 2.845)" :fill="svgFill" :stroke="svgStroke" stroke-linecap="round" stroke-linejoin="round" :stroke-width="svgStrokeWidth"/>
    </g>
  </svg>

</template>
<script>
export default {
  name: 'print',
  props: ['iconSize', 'iconFill', 'iconStroke', 'iconCssClass'],
  data() {
    return {
      svgWidth: "14.998",
      svgHeight: "14.187",
      svgFill: "none",
      svgStroke: "#236c6c",
      svgStrokeWidth: "2"
    }
  },
  computed: {
    getSize() {
      if (this.iconSize != undefined && this.iconSize !== "") {
        const multiplier = this.iconSize * 1
        this.svgWidth = this.svgWidth * multiplier
        this.svgHeight = this.svgHeight * multiplier
      }
    },
    getFill() {
      if (this.iconFill !== undefined && this.iconFill !== "") {
        return this.svgFill = this.iconFill
      }
      return this.svgFill
    },
    getStroke() {
      if (this.iconStroke !== undefined && this.iconStroke !== "") {
        this.svgStroke = this.iconStroke
      }
      return this.svgStroke
    }
  },
  mounted() {
    this.getSize
  }
}
</script>
